export const COLOR = [
  'primary',
  'secondary',
  'subdued',
  'disabled',
  'inverse',
  'highlight-01',
  'informational-01',
  'informational-02',
  'success-01',
  'success-02',
  'warning-01',
  'warning-02',
  'error-01',
  'error-02',
  'attention-01',
  'link-01',
  'link-01-inverse',
  'link-01-disabled',
]

export const WEIGHT = [
  'regular',
  'medium',
  'semi-bold',
  'bold',
]

export const VARIATION = [
  'caption-08',
  'caption-10',
  'caption-12',
  'body-14',
  'body-long-14',
  'body-16',
  'body-long-16',
  'subheading-18',
  'subheading-20',
  'heading-24',
  'heading-28',
  'heading-32',
  'heading-42',
]

export const TAG = [
  'p',
  'span',
  'ul',
  'li',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
]

export const LINK_STYLE = [
  'primary',
  'secondary',
  'inverse'
]
